import { jsx as _jsx } from "react/jsx-runtime";
import { Section } from "@react-email/components";
const cardStyle = {
    border: "1px solid #EBEBEB",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: "32px 33px 64px rgba(0, 0, 0, 0.06)",
    marginBottom: "20px"
};
export default function Card({ children }) {
    return (_jsx(Section, { style: cardStyle, children: children }));
}
